const MOBILE_BREAKPOINT = 768;
const MIN_MOBILE_SCALE = 0.65;
const DEFAULT_VIEWPORT = 'width=device-width, initial-scale=1.0';

function upsertViewportMetaTag() {
  let viewportMeta = document.querySelector<HTMLMetaElement>('meta[name="viewport"]');
  if (!viewportMeta) {
    viewportMeta = document.createElement('meta');
    viewportMeta.name = 'viewport';
    document.head.appendChild(viewportMeta);
  }
  return viewportMeta;
}

// Measure the device, not window.innerWidth: innerWidth changes with the initial-scale we
// set, and on Android Chrome that re-fires resize and flips the scale back and forth forever.
function getDeviceWidth() {
  const { width, height } = window.screen;
  const isLandscape = window.screen.orientation?.type?.startsWith('landscape') ?? width > height;
  return isLandscape ? Math.max(width, height) : Math.min(width, height);
}

function setViewportContent(viewportMeta: HTMLMetaElement, content: string) {
  // Rewriting an unchanged viewport tag still makes mobile browsers re-layout.
  if (viewportMeta.content !== content) {
    viewportMeta.content = content;
  }
}

function applyAdaptiveViewportScale() {
  const viewportMeta = upsertViewportMetaTag();
  const screenWidth = getDeviceWidth();
  const isMobile = screenWidth < MOBILE_BREAKPOINT;

  if (!isMobile) {
    setViewportContent(viewportMeta, DEFAULT_VIEWPORT);
    return;
  }

  // Keep very small phones usable while still scaling content down.
  const scale = Math.max(MIN_MOBILE_SCALE, Math.min(screenWidth / MOBILE_BREAKPOINT, 1));
  const fixedScale = scale.toFixed(3);
  setViewportContent(viewportMeta, `width=device-width, initial-scale=${fixedScale}`);
}

export function setupAdaptiveViewportScale() {
  applyAdaptiveViewportScale();

  // The scale depends only on the device, so it is re-applied on rotation alone. No 'resize'
  // listener: our own scale change and the soft keyboard both fire it.
  if (window.screen.orientation) {
    // Fires after screen dimensions settle, unlike the legacy orientationchange event.
    window.screen.orientation.addEventListener('change', applyAdaptiveViewportScale);
  } else {
    window.addEventListener('orientationchange', applyAdaptiveViewportScale, { passive: true });
  }
}
